import { render, staticRenderFns } from "./Algolia.vue?vue&type=template&id=53376150&"
import script from "./Algolia.vue?vue&type=script&lang=js&"
export * from "./Algolia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports